import { CookieScreen } from 'common-tracking';

import { styled, theme } from '../../stitches.config';
import { Button } from '../button';
import { Icon } from '../icons/icon';
import { Spacer } from '../spacer';
import { P } from '../text';

type Props = {
  allowAll: () => void;
  goToScreen: (screen: CookieScreen) => void;
};
export const DetailedCookieBanner = ({ goToScreen, allowAll }: Props) => {
  return (
    <DialogOverlay>
      <GdprDetails>
        <HeaderContainer>
          <Icon width={30} name={'lock'} variant={'regular'} />
          <GdprTitle>We value your privacy</GdprTitle>
        </HeaderContainer>
        <Spacer height={24} />
        <P
          css={{
            fontSize: '14px',
            fontWeight: '600',
            letterSpacing: '0',
            lineHeight: '21px',
          }}
        >
          Paperpal uses cookies and other data to deliver, maintain and improve
          our services and to provide a safer & better experience by
          personalising content, tailor and measure ads. You can click{' '}
          <strong>Set preferences</strong> to manage your cookie preferences or
          click on ‘ok’ to agree to usage of all cookies.
        </P>
      </GdprDetails>
      <GdprCTAContainer>
        <Button onClick={allowAll} css={{ width: '50%' }}>
          Allow All
        </Button>
        <Button
          color={'secondary'}
          onClick={() => {
            goToScreen('cookie-preference');
          }}
        >
          Set preferences
        </Button>
      </GdprCTAContainer>
    </DialogOverlay>
  );
};

const DialogOverlay = styled('div', {
  boxSizing: 'border-box',
  width: '80%',
  padding: '30px 40px',
  margin: '50px auto',
  borderRadius: '6px',
  bottom: '0px',
  display: 'flex',
  backgroundColor: theme.colors.white,
  boxShadow: '0 0 30px 0 rgb(0 0 0 / 30%)',
  position: 'fixed',
  left: '10%',
  zIndex: '9999',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
});

const GdprDetails = styled('div', {
  width: '100%',
  color: theme.colors.gray12,
  textAlign: 'left',
  fontSize: '14px',
  fontWeight: '600',
  letterSpacing: '0',
  lineHeight: '21px',
});

const GdprCTAContainer = styled('div', {
  display: 'flex',
  gap: '16px',
  justifyContent: 'center',
  alignItems: 'center',
});

const GdprTitle = styled('h2', {
  color: theme.colors.gray12,
  fontSize: '24px',
});

const HeaderContainer = styled('div', {
  display: 'flex',
  gap: 20,
  alignItems: 'center',
});
